import { Component, EventEmitter, Input, Output } from '@angular/core';
import { OrderListItem } from 'src/app/domain/models/LoadOrder';
import { BasicUser } from 'src/app/domain/models/User';

@Component({
  selector: 'app-table-row-card',
  templateUrl: './table-row-card.component.html',
  styleUrls: ['./table-row-card.component.css']
})
export class TableRowCardComponent {
  
  @Input() order!: OrderListItem
  @Input() year!: number | string
  @Input() profile: BasicUser | undefined
  @Input() isProgram: boolean | undefined

  @Output() viewPallets = new EventEmitter<OrderListItem>
  @Output() viewPackingList = new EventEmitter
  @Output() viewInstructive = new EventEmitter
  @Output() viewDocuments = new EventEmitter<OrderListItem>

  getIconUrl(iconUrl: string | undefined): string {
    return iconUrl ?? ''
  }

  onClickOpenPallets(order: OrderListItem) {
    this.viewPallets.emit(order)
  }

  onClickOpenPackingList(order: OrderListItem) {
    this.viewPackingList.emit(order.orderDetailId)
  }

  onClickOpenInstructive(order: OrderListItem) {
    this.viewInstructive.emit(order.orderDetailId)
  }

  onClickOpenDocuments(order: OrderListItem) {
    this.viewDocuments.emit(order)
  }

  onToggleDetail(order: OrderListItem) {
    if (order) {
      order.expanded = !order.expanded
    }
  }
}
